import AudioManager from "../Shared/AudioManager";
import PopWindowManager from "../Shared/PopWindowManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ReceiveAwardAni extends cc.Component {

    @property(cc.Label)
    labMoney: cc.Label = null;

    // 关闭按钮的回调函数
    callbackClose: Function = null;


    // onLoad () {}

    start () {
    }

    updateMoney(money){
        this.labMoney.string = money + "元";
        AudioManager.playSound("gold");
    }

    onBtnClick(event,param){
        AudioManager.playSound("close");
        PopWindowManager.openNext();
        this.callbackClose && this.callbackClose();
        this.node.destroy();
    }
}
